module.exports = __webpack_public_path__ + "Roboto-Medium.2b4f394ce87ea4e7a68b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Medium.svg
// module id = 203
// module chunks = 2